import React from 'react';
import PropTypes from 'prop-types';

const PrintIcon = (props) => {
  const {
    width, height, fill, className,
  } = props;

  const w = (width) ? width.toString().concat('px') : '24px';
  const h = (height) ? height.toString().concat('px') : '24px';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      className={(className) ? `icon ${className}` : 'icon'}
      viewBox="0 0 24 24"
      width={w}
      height={h}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
                // eslint-disable-next-line max-len
        d="M6.9 7.6V2.5H17.1V7.6H6.9ZM21 7.6H18.6V1.5C18.6 1.22386 18.3761 1 18.1 1H5.9C5.62386 1 5.4 1.22386 5.4 1.5V7.6H3C1.89543 7.6 1 8.49543 1 9.6V16.6C1 17.7046 1.89543 18.6 3 18.6H6.5V22.5C6.5 22.7761 6.72386 23 7 23H17C17.2761 23 17.5 22.7761 17.5 22.5V18.6H21C22.1046 18.6 23 17.7046 23 16.6V9.6C23 8.49543 22.1046 7.6 21 7.6ZM17.5 17.1H21C21.2761 17.1 21.5 16.8761 21.5 16.6V9.6C21.5 9.32386 21.2761 9.1 21 9.1H3C2.72386 9.1 2.5 9.32386 2.5 9.6V16.6C2.5 16.8761 2.72386 17.1 3 17.1H6.5V14.7C6.5 14.4239 6.72386 14.2 7 14.2H17C17.2761 14.2 17.5 14.4239 17.5 14.7V17.1ZM16 21.5H8V15.7H16V21.5Z"
        fill={(fill) || 'black'}
      />
    </svg>
  );
};

PrintIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
  className: PropTypes.string,
};

export default PrintIcon;
